import { Outlet } from 'react-router-dom';
import { Box } from '@mantine/core';

import { Header } from './Header';
import { Footer } from './Footer';

/** Shared shell — skip-nav, sticky header, main outlet, footer. */
export function SiteLayout() {
  return (
    <>
      <a href="#main-content" className="tf-skip-nav">
        Skip to main content
      </a>
      <Header />
      {/* Keyboard users land here via the skip-nav link, so we leave the
          default focus outline alone — the global :focus-visible rule paints
          a 2px forge ring on programmatic focus, giving sighted SR/keyboard
          users a clear "focus moved" signal. */}
      <Box
        id="main-content"
        component="main"
        tabIndex={-1}
        style={{ flex: 1 }}
      >
        <Outlet />
      </Box>
      <Footer />
    </>
  );
}
